export default "__VITE_ASSET__962b1ff1__"